<template>
    <v-dialog v-model="dialog" max-width="800">
        <template #activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" :disabled="disabled">
                <v-icon small>mdi-trash-can-outline</v-icon>
            </v-btn>
        </template>
        <v-card class="pa-5">
            <div class="d-flex align-center font-weight-bold mb-4">
                Are you absolutely sure?
                <v-spacer />
                <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <p>This action cannot be undone. This will permanently delete the <b>{{name}}</b> project.</p>

            <p>To delete Coroot components from your cluster, run the following command:</p>
            <pre class="hl">helm uninstall --namespace coroot coroot</pre>

            <p>To delete the project, please type <b>{{name}}</b></p>
            <v-text-field v-model="confirmation" outlined dense></v-text-field>
            <v-alert v-if="error" color="red" icon="mdi-alert-octagon-outline" outlined text>
                {{error}}
            </v-alert>
            <v-btn block color="red" outlined :disabled="confirmation !== name" :loading="loading" @click="del">
                <template v-if="$vuetify.breakpoint.mdAndUp">
                    I understand the consequences, delete this project
                </template>
                <template v-else>
                    Delete this project
                </template>
            </v-btn>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        workspaceId: String,
        projectId: String,
        name: String,
        disabled: Boolean,
    },
    data() {
        return {
            dialog: false,
            loading: false,
            confirmation: '',
            error: '',
        };
    },
    methods: {
        del() {
            this.loading = true;
            this.error = '';
            this.$api.delProject(this.workspaceId, this.projectId, (data, meta) => {
                this.loading = false;
                if (meta.error) {
                    this.error = meta.error;
                    return;
                }
                this.$events.emit('refresh', null);
                this.dialog = false;
                this.confirmation = '';
            })
        },
    },
}
</script>

<style scoped>

</style>